import type { MessengerThread } from '@/api/client';

const PREVIEW_MAX_LEN = 72;

export function truncateMessengerThreadListPreview(
  line: string,
  maxLen = PREVIEW_MAX_LEN
): string {
  return line.length > maxLen ? `${line.slice(0, maxLen - 1)}…` : line;
}

/**
 * Вторая строка в списке чатов (как превью последнего сообщения в Telegram).
 * Для групп: «Вы: текст» или «Имя: текст», для direct/user — только текст превью.
 */
export function getMessengerThreadListSubtitle(
  thread: MessengerThread | undefined,
  currentUserId?: string | null
): string {
  if (!thread?.id) return 'Начать чат';

  const previewRaw = thread.last_message_preview?.trim();
  if (!previewRaw) {
    if (!thread.last_message_at) return 'Начать чат';
    return 'Сообщение';
  }

  let line = previewRaw;
  if (thread.thread_kind === 'group') {
    const sid = thread.last_message_sender_id;
    if (sid) {
      const label =
        currentUserId != null && currentUserId !== '' && sid === currentUserId
          ? 'Вы'
          : (thread.last_message_sender_name?.trim() || 'Участник');
      line = `${label}: ${previewRaw}`;
    }
  }

  return truncateMessengerThreadListPreview(line);
}

/** Для сортировки по «давности чата»: новее выше. Нет треда / нет активности → 0. */
export function messengerThreadListActivityMs(t: MessengerThread | undefined): number {
  if (!t?.id) return 0;
  const raw = t.last_message_at;
  if (!raw) return 0;
  const ms = new Date(raw).getTime();
  return Number.isFinite(ms) ? ms : 0;
}
